import React from 'react';
import { AuthPageStyles } from '../../authentication/styles';
import { Box, Grid, Paper, Typography, useMediaQuery, useTheme, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ResponseReuseMessagePageStyles } from '../styles/ResponseReuseMessagePageStyles';
import { useParams, useHistory } from 'react-router-dom';
import { routeMappings, SessionStore } from '../../constants';
import { ResponseReuseRouteParam } from '../../taskList/constants';
import { useAppSelector } from '../../redux-store/hook';
import { getCookie } from '../utils/cookies';
import { RRMessageProps } from './../../basicTaskList/components/layout_01/BasicTaskListLayout';
import HtmlParser from 'react-html-parser';
import { BasicRRMessageStyles } from './../../basicTaskList/styles/BasicRRMessage';
import RRMessagePopup from './../../basicTaskList/components/RRMessagePopup';

export const ResponseReuseMessagePage = (): JSX.Element => {
  const currentWorkflowItem = useAppSelector((state) => state.currentWorkflowItem);
  const candidate = useAppSelector((state) => state.candidate);
  const history = useHistory();
  const { responseReuseType } = useParams<{ responseReuseType?: ResponseReuseRouteParam }>();
  const { t } = useTranslation();
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const classes = AuthPageStyles({ isICPEnabled: isICPEnabled });
  const styles = ResponseReuseMessagePageStyles();
  let heading,
    subHeading1,
    subHeading2: string | null = null;

  //for tcplus
  const rrMessageInfo: RRMessageProps = {
    buttonText: t('gotIt'),
    title: t('rrPopupTitle', {
      firstName: candidate?.firstName,
    }),
    subtitle1: t('prrPopupSubTitle5'),
    subtitle2: t('rrPopupSubTitle2'),
    subtitle3: t('rrPopupSubTitle3'),
    subtitle4: t('rrPopupSubTitle4'),
  };

  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  const tcPlusRRMessageclasses = BasicRRMessageStyles();
  if (responseReuseType) {
    if (tcPlusFlow && responseReuseType === ResponseReuseRouteParam.COMPLETE_RR) {
      rrMessageInfo.subtitle1 = t('frrPopupSubTitle1');
      rrMessageInfo.buttonText = t('rrProceedButton');
    } else {
      switch (responseReuseType) {
        case ResponseReuseRouteParam.COMPLETE_RR:
          heading = t('fullRRPageMsgForAllTasksHeader');
          subHeading1 = t('fullRRPageMsg1', { firstName: candidate?.firstName });
          subHeading2 = t('fullRRPageMsg2All');
          break;
        case ResponseReuseRouteParam.FULL_RR:
          heading = t('fullRRMsgForSingleTaskHeader');
          subHeading1 = t('fullRRPageMsg1', { firstName: candidate?.firstName });
          subHeading2 = t('fullRRPageMsg2Single');
          break;
        case ResponseReuseRouteParam.PARTIAL_RR:
          heading = t('partialRRHeadingPage');
          subHeading1 = `${t('partialRRMsg1OnTaskPage')} ${t('partialRRMsg2OnTaskPage')}`;
          break;
        default:
          break;
      }
    }
  }

  const onSubmit = (): void => {
    if (tcPlusFlow) {
      const rrMsgRead = sessionStorage.getItem(SessionStore.basicRRMsgRead) !== 'true';
      if (rrMsgRead) sessionStorage.setItem(SessionStore.basicRRMsgRead, 'true');
    }
    sessionStorage.setItem(SessionStore.responseReuseAcknowledged, '1');
    history.push(`${routeMappings[currentWorkflowItem.code]}/${currentWorkflowItem.id}`);
  };

  const AdvancedRRMessageLayout = (): JSX.Element => {
    return (
      <>
        {smUp ? (
          <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center">
            <Typography
              color="inherit"
              variant="h2"
              align="center"
              className={tcPlusRRMessageclasses.advancedRRPageTitle}>
              {rrMessageInfo.title}
            </Typography>
            <Typography color="inherit" align="center" className={tcPlusRRMessageclasses.advancedRRPageContent}>
              {rrMessageInfo.subtitle1}
              <br />
              {rrMessageInfo.subtitle2}
            </Typography>
            <Typography color="inherit" align="center" className={tcPlusRRMessageclasses.advancedRRPageContent}>
              {rrMessageInfo.subtitle3}
              <br />
              {HtmlParser(rrMessageInfo.subtitle4)}
            </Typography>
            <Box textAlign={'center'}>
              <Button type="submit" variant="outlined" color="primary" aria-disabled="false" onClick={onSubmit}>
                {rrMessageInfo.buttonText}
              </Button>
            </Box>
          </Box>
        ) : (
          <RRMessagePopup
            title={t(rrMessageInfo.title, { firstName: candidate?.firstName })}
            subtitle1={t(rrMessageInfo.subtitle1)}
            subtitle2={t(rrMessageInfo.subtitle2)}
            subtitle3={t(rrMessageInfo.subtitle3)}
            subtitle4={t(rrMessageInfo.subtitle4)}
            buttonText={t(rrMessageInfo.buttonText)}
            showRRPopup={true}
            onRRMsgBtnClick={onSubmit}
          />
        )}
      </>
    );
  };

  return (
    <Grid container justify="center" className={classes.container}>
      <Grid item xl={tcPlusFlow ? 8 : 6} lg={tcPlusFlow ? 10 : 8} className={classes.grid}>
        <Paper elevation={lgUp ? 1 : 0} className={classes.paper}>
          {tcPlusFlow ? (
            <AdvancedRRMessageLayout />
          ) : (
            <>
              {heading && <Typography variant="h2">{heading}</Typography>}
              <Box
                display="flex"
                justifyContent="center"
                flexDirection="column"
                alignItems="center"
                className={styles.outerBox}>
                <Box mt={2} p={2} className={styles.innerBox}>
                  {subHeading1 && <Typography variant="body1">{subHeading1}</Typography>}
                  {subHeading2 && (
                    <Typography variant="body1" className={`${styles.pos}`}>
                      {subHeading2}
                    </Typography>
                  )}
                </Box>
                <Button type="submit" variant="outlined" color="primary" aria-disabled="false" onClick={onSubmit}>
                  {t('gotIt')}
                </Button>
              </Box>
            </>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};
